import React from "react";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div>

      {/* HERO SECTION */}
      <section className="bg-gradient-to-r from-blue-900 to-blue-700 text-white py-24">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 items-center gap-10 px-6">

          <div>
            <h1 className="text-5xl font-bold mb-6 leading-tight">
              Enterprise ERP, Data Analytics & AI Solutions
            </h1>

            <p className="text-lg mb-8 text-blue-100">
              Driving Digital Transformation & Business Growth through intelligent
              ERP platforms, data analytics, and AI innovation.
            </p>

            <Link to="/services">
              <button className="bg-red-500 px-6 py-3 rounded-lg hover:bg-red-600 transition">
                Explore Our Services
              </button>
            </Link>
          </div>

          <div>
            <img
              src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1200"
              alt="analytics"
              className="rounded-xl shadow-2xl"
            />
          </div>

        </div>
      </section>

      {/* SERVICES */}
      <section className="py-20 bg-gray-100">

        <h2 className="text-4xl text-center font-bold text-blue-800 mb-12">
          Our Core Services
        </h2>

        <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-4 gap-8 px-6">

          {[
           {
              title: "Enterprise ERP",
              image: process.env.PUBLIC_URL + "/erp-enterprise.png",
           },
            {
              title: "AI-Driven Innovations",
              image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=1200",
            },
            {
              title: "Data Analytics Solutions",
              image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1200",
            },
            {
              title: "Oracle EBS Modernizations",
              image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=1200",
            },
            {
              title: "IT Strategy Consulting",
              image: "https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=1200",
            },
            {
              title: "AI & Digital Solutions",
              image: "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=1200",
            },
            {
              title: "Staff Augmentation Services",
              image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?q=80&w=1200",
            },
            {
              title: "Solutions & Training",
              image: "https://images.unsplash.com/photo-1509062522246-3755977927d7?q=80&w=1200",
            }
          ].map((service, index) => (

            <Link to="/services" key={index}>
              <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:scale-105 transition duration-300 cursor-pointer group">

                <div className="relative">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-40 object-cover"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition"></div>
                </div>

                <div className="p-4 text-center">
                  <h3 className="text-lg font-semibold text-blue-700">
                    {service.title}
                  </h3>
                </div>

              </div>
            </Link>

          ))}

        </div>

        <div className="text-center mt-10">
          <Link to="/services">
            <button className="bg-red-600 text-white px-6 py-3 rounded hover:bg-red-700 transition">
              Explore All Services
            </button>
          </Link>
        </div>

      </section>

      {/* INDUSTRIES */}
      <section className="py-10 bg-white">

        <h2 className="text-4xl text-center font-bold text-blue-800 mb-8">
          Industries We Serve
        </h2>

        <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-4 gap-8 px-6">

          {[
            {
              title: "Healthcare",
              image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?q=80&w=1200",
            },
            {
              title: "Banking & Finance",
              image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?q=80&w=1200",
            },
            {
              title: "Renewable Energy",
              image: "https://images.unsplash.com/photo-1509395176047-4a66953fd231?q=80&w=1200",
            },
            {
              title: "AI Automation",
              image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=1200",
            }
          ].map((industry, index) => (

            <div
              key={index}
              className="bg-gray-50 rounded-lg shadow-lg overflow-hidden hover:scale-105 transition duration-300"
            >
              <img
                src={industry.image}
                alt={industry.title}
                className="w-full h-48 object-cover"
              />

              <div className="p-4 text-center">
                <h3 className="text-lg font-semibold text-blue-700">
                  {industry.title}
                </h3>
              </div>
            </div>

          ))}

        </div>

        <div className="text-center mt-8">
          <Link to="/industries">
            <button className="bg-red-600 text-white px-8 py-3 rounded hover:bg-red-700 transition">
              Explore All Industries
            </button>
          </Link>
        </div>

      </section>

      {/* AI TOOLS */}
      <section className="bg-gray-100 py-10">
        <div className="max-w-7xl mx-auto px-6">

          <h2 className="text-4xl text-center font-bold text-blue-800 mb-8">
            Advanced AI Tools
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">

            {[
              {
                title: "Tax Calculator",
                description: "Estimate tax liabilities using AI-driven calculations.",
                image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=1200",
              },
              {
                title: "Finance Advisor",
                description: "Get AI-powered financial insights and investment guidance.",
                image: "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?q=80&w=1200",
              },
              {
                title: "Stock Analyzer",
                description: "Analyze stocks, track market trends, and get real-time investment insights instantly.",
                image: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?q=80&w=1200",
              },
              {
                title: "KPI Dashboard Builder",
                description: "Build and visualize key performance indicators in real time.",
                image: "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?q=80&w=1200",
              },

            ].map((tool, index) => (

              <div
                key={index}
                className="bg-white rounded-lg shadow-lg overflow-hidden hover:scale-105 transition duration-300"
              >
                <img
                  src={tool.image}
                  alt={tool.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-4 text-center">
                  <h3 className="text-lg font-semibold text-blue-700">
                    {tool.title}
                  </h3>
                </div>
              </div>

            ))}

          </div>

          {/* Explore All AI Tools button */}
          <div className="text-center mt-8">
            <Link to="/ai-tools">
              <button className="bg-red-600 text-white px-8 py-3 rounded hover:bg-red-700 transition">
                Explore All AI Tools
              </button>
            </Link>
          </div>

        </div>
      </section>

      {/* CTA SECTION */}
      <section className="bg-white text-lg font-semibold py-10 text-center">
        <h2 className="text-3xl font-semibold mb-3">
          Let's Accelerate Your Business Success
        </h2>
        <p className="text-gray-600 mb-6 text-sm">
          Get in touch with our experts to start your digital transformation journey.
        </p>
        <Link to="/contact">
          <button className="bg-red-600 text-white px-8 py-3 rounded hover:bg-red-700 transition">
            Get Started Today
          </button>
        </Link>
      </section>

    </div>
  );
}

export default Home;